<template>
  <section class="container-fluid p-0 bodyArea">
    <div class="containerBox">
      <iframe :src="embedUrl" style="width: 100%; height: 100vh;"></iframe>
    </div>
  </section>
</template>

<script>
import Vue from "vue";
import "vue-loading-overlay/dist/vue-loading.css";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";

Vue.use(VueToast);
export default {
  name: "DeviceStatusReports",
  data() {
    return {
      embedUrl: '',
    };
  },
  created() {
    this.getDevicesStatusReportBeta();
  },
  methods: {
    async getDevicesStatusReportBeta() {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url = config.REPORTS_SERVICE + `/tenants/${config.LOOKER_TENANT}/looker/embed-url`;
      var deviceReport = new Request(url, {
        method: "POST",
        mode: "cors",
        withCredentials: "include",
        credentials: "include",
        cache: "default",
        body: JSON.stringify({
          "report_name": "Device Status Report",
          "index_id": 11,
          "isDefault": true,
          "icon": "icon-rounding",
          "isLookerReportType": true,
          "report_url": config.DEVICE_STATUS_URL,
          "name": "Device Status Report",
          "value": 11
        }),
        headers: {
          Authorization: "Bearer " + id_token,
          "content-type": "application/json",
        },
      });
      try {
        var deviceReportResponse = await fetch(deviceReport);
        if (deviceReportResponse.status == 503) {
          return this.getDevicesStatusReportBeta();
        } else {
          let data = await deviceReportResponse.json();
          this.embedUrl = `${data.url}`;
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
<style>
@font-face {
  font-family: GTWalsheimPro-Regular;
  src: url(/assets/fonts/GTWalsheimPro-Regular.eot);
  src: url(/assets/fonts/GTWalsheimPro-Regular.eot) format("embedded-opentype"),
    url(/assets/fonts/GTWalsheimPro-Regular.ttf) format("truetype"),
    url(/assets/fonts/GTWalsheimPro-Regular.svg) format("svg");
  font-weight: normal;
  font-style: normal;
}
</style>
<style lang="scss">
.cadatepicker {
  border: 1px solid #d9dada;
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  border-radius: 5px;
  color: #8f8991;
  font-size: 16px;
}

.ca-datepicker:focus {
  border: 1px solid #d9dada;
}

input.cadatepicker:focus-visible {
  outline: none;
}

.vdp-datepicker__calendar {
  right: 0px;
  margin-top: 1px;
  border-radius: 5px;
  color: #8f8991;
  font-size: 16px;
  padding: 10px;
}

.vdp-datepicker__calendar .cell.day-header {
  font-size: 16px !important;
  color: #1dd8f6 !important;
}

.vdp-datepicker__calendar .cell.selected {
  background: #51b9d5;
  color: #fff;
}

.vdp-datepicker__calendar header .prev:after {
  border-right: 10px solid #f27778 !important;
}

.vdp-datepicker__calendar header .next:after {
  border-left: 10px solid #f27778 !important;
}

@media (max-width: 1366px) {
  .menuItem {
    padding-left: 15px;
  }

  .avatarStyle {
    float: left;
  }

  .username {
    max-width: 190px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
  }
}
</style>

<style lang="scss" scoped>
@font-face {
  font-family: GTWalsheimPro-Regular;
  src: url(../assets/fonts/GTWalsheimPro-Regular.eot);
  src: url(../assets/fonts/GTWalsheimPro-Regular.eot) format("embedded-opentype"),
    url(../assets/fonts/GTWalsheimPro-Regular.ttf) format("truetype"),
    url(../assets/fonts/GTWalsheimPro-Regular.svg) format("svg");
  font-weight: normal;
  font-style: normal;
}

*,
:after,
:before {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

body,
html {
  font-family: GTWalsheimPro-Regular !important;
  background: #fff !important;
  font-size: 16px;
  overflow-x: hidden;
}

b,
strong {
  font-weight: 500;
}

button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  // -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
html input[disabled] {
  cursor: default;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
  outline: 0 !important;
}

a,
a img,
a:active,
a:focus,
button:focus,
a:hover {
  outline: 0 !important;
  -webkit-transition: all 0.35s;
  -moz-transition: all 0.35s;
  transition: all 0.35s;
  text-decoration: none;
  cursor: pointer;
  color: #5ed1d1;
}

a:hover {
  text-decoration: underline;
}

img {
  border: 0 !important;
}

a:focus:not(:hover),
button:focus:not(:hover) {
  outline: 0;
}

::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: rgba(4, 78, 89, 1) !important;
}

::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba(4, 78, 89, 1) !important;
}

:-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(4, 78, 89, 1) !important;
}

:-moz-placeholder {
  /* Firefox 18- */
  color: rgba(4, 78, 89, 1) !important;
}

.requiredItem::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #dc858b !important;
}

.requiredItem::-moz-placeholder {
  /* Firefox 19+ */
  color: #dc858b !important;
}

.requiredItem:-ms-input-placeholder {
  /* IE 10+ */
  color: #dc858b !important;
}

.requiredItem:-moz-placeholder {
  /* Firefox 18- */
  color: #dc858b !important;
}

input[type="text"],
input[type="email"],
input[type="search"],
input[type="number"],
input[type="password"],
input[type="tel"],
input[type="date"],
select.form-control,
textarea.form-control {
  box-shadow: none;
  background: transparent;
  outline: none !important;
  border: 1px solid #dceaea;
  border-radius: 5px;
  width: 100%;
  padding: 7px 15px;
  color: #6a6a6a;
}

input[type="text"]:focus,
input[type="email"]:focus,
input[type="search"]:focus,
input[type="number"]:focus,
input[type="password"]:focus,
input[type="tel"]:focus,
input[type="date"]:focus,
select.form-control:focus,
textarea.form-control:focus {
  box-shadow: none;
  background: transparent;
  outline: none !important;
}

input[type="text"].requiredItem:focus,
input[type="email"].requiredItem:focus,
input[type="search"].requiredItem:focus,
input[type="number"].requiredItem:focus,
input[type="password"].requiredItem:focus,
input[type="tel"].requiredItem:focus,
input[type="date"].requiredItem:focus,
select.form-control.requiredItem:focus,
textarea.form-control.requiredItem:focus,
textarea.requiredItem:focus {
  box-shadow: none;
  background: transparent;
  outline: none !important;
  border-bottom: 1px solid #dc858b;
}

input[type="text"]:hover,
input[type="email"]:hover,
input[type="search"]:hover,
input[type="number"]:hover,
input[type="password"]:hover,
input[type="tel"]:hover,
input[type="date"]:hover,
select.form-control:hover,
textarea.form-control:hover {
  box-shadow: none;
  background: #fff;
  outline: none !important;
}

input[type="text"].requiredItem:hover,
input[type="email"].requiredItem:hover,
input[type="search"].requiredItem:hover,
input[type="number"].requiredItem:hover,
input[type="password"].requiredItem:hover,
input[type="tel"].requiredItem:hover,
input[type="date"].requiredItem:hover,
select.form-control.requiredItem:hover,
textarea.form-control.requiredItem:hover {
  box-shadow: none;
  background: transparent;
  outline: none !important;
}

input[type="text"]:hover::-webkit-input-placeholder,
input[type="email"]:hover::-webkit-input-placeholder,
input[type="search"]:hover::-webkit-input-placeholder,
input[type="number"]:hover::-webkit-input-placeholder,
input[type="password"]:hover::-webkit-input-placeholder,
input[type="tel"]:hover::-webkit-input-placeholder,
input[type="date"]:hover::-webkit-input-placeholder,
select.form-control:hover::-webkit-input-placeholder,
textarea.form-control:hover::-webkit-input-placeholder,
textarea:hover::-webkit-input-placeholder,
input[type="text"]:focus::-webkit-input-placeholder,
input[type="email"]:focus::-webkit-input-placeholder,
input[type="search"]:focus::-webkit-input-placeholder,
input[type="number"]:focus::-webkit-input-placeholder,
input[type="password"]:focus::-webkit-input-placeholder,
input[type="tel"]:focus::-webkit-input-placeholder,
input[type="date"]:focus::-webkit-input-placeholder,
select.form-control:focus::-webkit-input-placeholder,
textarea.form-control:focus::-webkit-input-placeholder,
textarea:focus::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #fff !important;
}

input[type="text"].requiredItem:hover::-webkit-input-placeholder,
input[type="email"].requiredItem:hover::-webkit-input-placeholder,
input[type="search"].requiredItem:hover::-webkit-input-placeholder,
input[type="number"].requiredItem:hover::-webkit-input-placeholder,
input[type="password"].requiredItem:hover::-webkit-input-placeholder,
input[type="tel"].requiredItem:hover::-webkit-input-placeholder,
input[type="date"].requiredItem:hover::-webkit-input-placeholder,
select.form-control.requiredItem:hover::-webkit-input-placeholder,
textarea.form-control.requiredItem:hover::-webkit-input-placeholder,
textarea.requiredItem:hover::-webkit-input-placeholder,
input[type="text"].requiredItem:focus::-webkit-input-placeholder,
input[type="email"].requiredItem:focus::-webkit-input-placeholder,
input[type="search"].requiredItem:focus::-webkit-input-placeholder,
input[type="number"].requiredItem:focus::-webkit-input-placeholder,
input[type="password"].requiredItem:focus::-webkit-input-placeholder,
input[type="tel"].requiredItem:focus::-webkit-input-placeholder,
input[type="date"].requiredItem:focus::-webkit-input-placeholder,
select.form-control.requiredItem:focus::-webkit-input-placeholder,
textarea.form-control.requiredItem:focus::-webkit-input-placeholder,
textarea.requiredItem:focus::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #dc858b !important;
}

input[type="text"]:hover::-moz-placeholder,
input[type="email"]:hover::-moz-placeholder,
input[type="search"]:hover::-moz-placeholder,
input[type="number"]:hover::-moz-placeholder,
input[type="password"]:hover::-moz-placeholder,
input[type="tel"]:hover::-moz-placeholder,
input[type="date"]:hover::-moz-placeholder,
select.form-control:hover::-moz-placeholder,
textarea:hover::-moz-placeholder,
textarea.form-control:hover::-moz-placeholder,
input[type="text"]:focus::-moz-placeholder,
input[type="email"]:focus::-moz-placeholder,
input[type="search"]:focus::-moz-placeholder,
input[type="number"]:focus::-moz-placeholder,
input[type="password"]:focus::-moz-placeholder,
input[type="tel"]:focus::-moz-placeholder,
input[type="date"]:focus::-moz-placeholder,
select.form-control:focus::-moz-placeholder,
textarea.form-control:focus::-moz-placeholder,
textarea:focus::-moz-placeholder {
  /* Firefox 19+ */
  color: #fff !important;
}

input[type="text"].requiredItem:hover::-moz-placeholder,
input[type="email"].requiredItem:hover::-moz-placeholder,
input[type="search"].requiredItem:hover::-moz-placeholder,
input[type="number"].requiredItem:hover::-moz-placeholder,
input[type="password"].requiredItem:hover::-moz-placeholder,
input[type="tel"].requiredItem:hover::-moz-placeholder,
input[type="date"].requiredItem:hover::-moz-placeholder,
select.form-control.requiredItem:hover::-moz-placeholder,
textarea.form-control.requiredItem:hover::-moz-placeholder,
input[type="text"].requiredItem:focus::-moz-placeholder,
input[type="email"].requiredItem:focus::-moz-placeholder,
input[type="search"].requiredItem:focus::-moz-placeholder,
input[type="number"].requiredItem:focus::-moz-placeholder,
input[type="password"].requiredItem:focus::-moz-placeholder,
input[type="tel"].requiredItem:focus::-moz-placeholder,
input[type="date"].requiredItem:focus::-moz-placeholder,
select.form-control.requiredItem:focus::-moz-placeholder,
textarea.form-control.requiredItem:focus::-moz-placeholder {
  /* Firefox 19+ */
  color: #dc858b !important;
}

input[type="text"]:hover:-ms-input-placeholder,
input[type="email"]:hover:-ms-input-placeholder,
input[type="search"]:hover:-ms-input-placeholder,
input[type="number"]:hover:-ms-input-placeholder,
input[type="password"]:hover:-ms-input-placeholder,
input[type="tel"]:hover:-ms-input-placeholder,
input[type="date"]:hover:-ms-input-placeholder,
select.form-control:hover:-ms-input-placeholder,
textarea.form-control:hover:-ms-input-placeholder,
input[type="text"]:focus:-ms-input-placeholder,
input[type="email"]:focus:-ms-input-placeholder,
input[type="search"]:focus:-ms-input-placeholder,
input[type="number"]:focus:-ms-input-placeholder,
input[type="password"]:focus:-ms-input-placeholder,
input[type="tel"]:focus:-ms-input-placeholder,
input[type="date"]:focus:-ms-input-placeholder,
select.form-control:focus:-ms-input-placeholder,
textarea.form-control:focus:-ms-input-placeholder {
  /* IE 10+ */
  color: #fff !important;
}

input[type="text"].requiredItem:hover:-ms-input-placeholder,
input[type="email"].requiredItem:hover:-ms-input-placeholder,
input[type="search"].requiredItem:hover:-ms-input-placeholder,
input[type="number"].requiredItem:hover:-ms-input-placeholder,
input[type="password"].requiredItem:hover:-ms-input-placeholder,
input[type="tel"].requiredItem:hover:-ms-input-placeholder,
input[type="date"].requiredItem:hover:-ms-input-placeholder,
select.form-control.requiredItem:hover:-ms-input-placeholder,
textarea.form-control.requiredItem:hover:-ms-input-placeholder,
input[type="text"].requiredItem:focus:-ms-input-placeholder,
input[type="email"].requiredItem:focus:-ms-input-placeholder,
input[type="search"].requiredItem:focus:-ms-input-placeholder,
input[type="number"].requiredItem:focus:-ms-input-placeholder,
input[type="password"].requiredItem:focus:-ms-input-placeholder,
input[type="tel"].requiredItem:focus:-ms-input-placeholder,
input[type="date"].requiredItem:focus:-ms-input-placeholder,
select.form-control.requiredItem:focus:-ms-input-placeholder,
textarea.form-control.requiredItem:focus:-ms-input-placeholder {
  /* IE 10+ */
  color: #dc858b !important;
}

input[type="text"]:hover:-moz-placeholder,
input[type="email"]:hover:-moz-placeholder,
input[type="search"]:hover:-moz-placeholder,
input[type="number"]:hover:-moz-placeholder,
input[type="password"]:hover:-moz-placeholder,
input[type="tel"]:hover:-moz-placeholder,
input[type="date"]:hover:-moz-placeholder,
select.form-control:hover:-moz-placeholder,
textarea.form-control:hover:-moz-placeholder,
input[type="text"]:focus:-moz-placeholder,
input[type="email"]:focus:-moz-placeholder,
input[type="search"]:focus:-moz-placeholder,
input[type="number"]:focus:-moz-placeholder,
input[type="password"]:focus:-moz-placeholder,
input[type="tel"]:focus:-moz-placeholder,
input[type="date"]:focus:-moz-placeholder,
select.form-control:focus:-moz-placeholder,
textarea.form-control:focus:-moz-placeholder {
  /* Firefox 18- */
  color: #fff !important;
}

input[type="text"].requiredItem:hover:-moz-placeholder,
input[type="email"].requiredItem:hover:-moz-placeholder,
input[type="search"].requiredItem:hover:-moz-placeholder,
input[type="number"].requiredItem:hover:-moz-placeholder,
input[type="password"].requiredItem:hover:-moz-placeholder,
input[type="tel"].requiredItem:hover:-moz-placeholder,
input[type="date"].requiredItem:hover:-moz-placeholder,
select.form-control.requiredItem:hover:-moz-placeholder,
textarea.form-control.requiredItem:hover:-moz-placeholder,
input[type="text"].requiredItem:focus:-moz-placeholder,
input[type="email"].requiredItem:focus:-moz-placeholder,
input[type="search"].requiredItem:focus:-moz-placeholder,
input[type="number"].requiredItem:focus:-moz-placeholder,
input[type="password"].requiredItem:focus:-moz-placeholder,
input[type="tel"].requiredItem:focus:-moz-placeholder,
input[type="date"].requiredItem:focus:-moz-placeholder,
select.form-control.requiredItem:focus:-moz-placeholder,
textarea.form-control.requiredItem:focus:-moz-placeholder {
  /* Firefox 18- */
  color: #dc858b !important;
}

::-moz-selection {
  /* Code for Firefox */
  color: #fbeeef;
  background: #202533;
}

::selection {
  color: #fbeeef;
  background: #202533;
}

/* Scroll Bar Styling */

/* width */
::-webkit-scrollbar {
  width: 5px;
  border-radius: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f2fdff;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #a6e3f0;
  border-radius: 10px;
}

/* Checkbox CSS Starts here */
.checkbox-container {
  display: block;
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-bottom: 0;
  color: #6a6a6a;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 4px;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #ffffff;
  border: 1px solid #e7e7e7;
  border-radius: 3px;
}

/* On mouse-over, add a grey background color */
.checkbox-container:hover input~.checkmark {
  border: 1px solid #1dd8f6;
}

/* When the checkbox is checked, add a blue background */
.checkbox-container input:checked~.checkmark {
  background-color: #1dd8f6;
  border: 1px solid #1dd8f6;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked~.checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

/* Checkbox CSS ends here */
.bodyArea {
  font-family: GTWalsheimPro-Regular;
}

/* Header CSS */
.headerWrapper {
  height: 80px;
  border-bottom: 1px solid #e5f0f2;
  width: 100%;
  padding: 0 15px;
}

a.userMenuDropDown {
  background: transparent;
  border: 0px solid;
  color: #6a6a6a;
  padding: 0;
  text-decoration: none;
}

.userMenuDropDown img {
  padding-right: 15px;
}

a.userMenuDropDown::after {
  position: relative;
  top: 2px;
  margin-left: 15px;
}

a.userMenuDropDown:hover {
  color: #1dd8f6;
}

.userMenuDropDownData {
  top: 30px !important;
  padding: 0 !important;
  border-radius: 0;
  border-top: 0px solid;
}

.userMenuDropDownData a {
  padding: 0 15px;
  line-height: 40px;
}

.userMenuDropDownData a:hover {
  color: #1dd8f6;
  background: #f2fdff;
}

.menuItemsWrapper {
  border-right: 1px solid #e5f0f2;
  padding-right: 15px !important;
  margin-right: 15px !important;
}

.menuItem {
  align-items: center;
  display: inline-flex;
  padding-left: 40px;
  position: relative;
  color: #6a6a6a;
}

.menuItem>a {
  color: #6a6a6a;
  text-decoration: none;
}

.menuItem:hover,
.menuItem.active {
  color: #1dd8f6;
  cursor: pointer;
}

.menuItem:hover>a,
.menuItem.active>a {
  color: #1dd8f6;
  cursor: pointer;
  text-decoration: none;
}

.menuItem img {
  padding-right: 10px;
  width: 30px;
}

.menuItem:after,
.menuItem:after {
  content: "";
  background: #f27778;
  height: 3px;
  width: 0;
  position: absolute;
  top: 49px;
  transition: 0.5s;
  opacity: 0;
}

.menuItem:hover:after,
.menuItem.active:after {
  width: calc(100% - 40px);
  opacity: 1;
}

.statistics {
  display: inline-flex;
  padding-left: 20px;
  margin-left: 20px;
  border-left: 1px solid #e5f0f2;
  color: #1dd8f6;
  font-size: 22px;
  align-items: flex-end;
  line-height: 25px;
}

.statistics>span {
  color: #6a6a6a;
  font-size: 19px;
  line-height: 1;
}

.dashboardBlocksWrapper {
  padding: 30px 15px;
  background: #f2fdff;
  border-bottom: 1px solid #e5f0f2;
  gap: 15px;
}

.dashboardBlock {
  background: red;
  margin: 0;
  padding: 15px;
  border-radius: 10px;
}

.dashboardBlock .dashboardNumber {
  width: 100%;
  font-size: 32px;
}

.dashboardIcon {
  float: left;
  margin-right: 10px;
}

.dashboardNumber {
  float: left;
  //font-size: 45px;
  color: #1dd8f6;
  line-height: 1;
}

.dashboardNumber>span {
  font-size: 16px;
  display: block;
  color: #6a6a6a;
}

.dashboardIcon img {
  filter: invert(39%) sepia(52%) saturate(3073%) hue-rotate(139deg) brightness(111%) contrast(96%);
}

.dashboardBlock {
  border: 1px solid #d9dada;
  background: #fff !important;
  display: flex;
  align-items: center;
}

.dashboardBlock:first-child {
  background: rgb(0, 192, 255);
  background: linear-gradient(45deg,
      rgba(0, 192, 255, 1) 0%,
      rgba(0, 192, 255, 1) 35%,
      rgba(26, 102, 168, 1) 100%);
}

.dashboardBlock:nth-child(2) {
  background: rgb(0, 255, 169);
  background: linear-gradient(45deg,
      rgba(0, 255, 169, 1) 0%,
      rgba(13, 77, 255, 1) 100%);
}

.dashboardBlock:nth-child(3) {
  background: rgb(31, 201, 253);
  background: linear-gradient(45deg,
      rgba(31, 201, 253, 1) 0%,
      rgba(252, 0, 97, 1) 100%);
}

.dashboardBlock:nth-child(4) {
  background: rgb(163, 44, 223);
  background: linear-gradient(45deg,
      rgba(163, 44, 223, 1) 0%,
      rgba(138, 54, 220, 1) 33%,
      rgba(77, 79, 215, 1) 66%,
      rgba(16, 106, 210, 1) 100%);
}

.dashboardBlock:nth-child(5) {
  background: rgb(0, 255, 255);
  background: linear-gradient(45deg,
      rgba(0, 255, 255, 1) 0%,
      rgba(147, 39, 143, 1) 100%);
}

.dashboardBlock:nth-child(6) {
  background: rgb(163, 44, 223);
  background: linear-gradient(45deg,
      rgba(163, 44, 223, 1) 0%,
      rgba(138, 54, 220, 1) 33%,
      rgba(77, 79, 215, 1) 66%,
      rgba(16, 106, 210, 1) 100%);
}

.dashboardBlock:last-child {
  background: rgb(254, 193, 148);
  background: linear-gradient(45deg,
      rgba(254, 193, 148, 1) 0%,
      rgba(254, 168, 141, 1) 30%,
      rgba(254, 107, 125, 1) 50%,
      rgba(254, 8, 99, 1) 70%,
      rgba(255, 0, 97, 1) 100%);
}

.facilityInfoWrapper {
  overflow: auto;
  max-height: calc(100vh - 262px);
}

.facilityInfoRow {
  padding: 30px 15px 30px 15px;
  background: #fff;
  width: 100%;
  gap: 15px;
}

.facilityInfo {
  color: #6a6a6a;
  font-size: 14px;
  border: 1px solid #e5f0f2;
  border-radius: 10px;
  padding: 0;
  flex: 1 0 19%;
  max-width: 365px;
}

.facilityInfo .dashboardNumber {
  color: #1a80a8;
  padding: 15px;
  font-size: 32px;
  min-width: 75px;
  text-align: center;
}

.facilityName {
  background: #f2fdff;
  color: #1dd8f6;
  font-size: 16px;
  text-align: left;
  padding: 10px 15px;
  border-radius: 0 0 10px 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
}

.infoWrapper {
  padding: 15px;
  border-left: 1px solid #e5f0f2;
}

.infoItem {
  display: flex;
  line-height: 30px;
}

.infoItem img {
  width: 15px;
  margin-right: 5px;
}

.pageHeader {
  height: 56px;
  color: #fff;
  background: #484848;
  font-size: 15px;
  padding: 0 15px;
}

.filterWrapper {
  background: #1dd8f6;
  display: inline-flex;
  padding: 2px 15px;
  font-size: 16px;

  min-width: 250px;
  max-width: 250px;
  border-radius: 5px;
  margin-left: 15px;

  text-overflow: ellipsis;
}

.filterText {
  color: #fff;
  opacity: 0.4;
  padding-right: 20px;
}

.filterInputText {
  max-width: 215px !important;
  background: #1dd8f6 !important;
  outline: none !important;
  border: 1px solid #1dd8f6 !important;
  //background: rgba(255,255,255,0.5) !important;
  color: #fff !important;
  padding: 5px 15px !important;
}

.filterWrapper .dropdown {
  width: 100%;
  text-align: left;
}

.filterDropDown {
  color: #fff;
  opacity: 1;
  text-decoration: none;
  width: 100%;
  display: inline-block;
}

.filterDropDown:after {
  float: right;
  position: relative;
  top: 10px;
}

.filterDropDown:hover {
  text-decoration: none;
}

.filterDropDownData,
.actionDropDownData {
  padding: 0;
  border-radius: 0;
  top: 21px !important;
  border: 1px solid #e5f0f2;
}

.actionDropDownData {
  top: 10px !important;
}

.filterDropDownData>a,
.actionDropDownData>a {
  color: #6a6a6a;
  text-decoration: none;
  padding: 5px 15px;
  position: relative;
}

.filterDropDownData>a:hover,
.filterDropDownData>a.active,
.actionDropDownData>a:hover,
.actionDropDownData>a.active {
  text-decoration: none;
  background: #f2fdff;
  color: #1dd8f6;
}

.filterDropDownData>a::after,
.actionDropDownData>a::after {
  content: "";
  height: 1px;
  width: 70%;
  left: 15%;
  position: absolute;
  bottom: 0;
  background: #daf9ff;
}

.filterDropDownData>a:last-child::after,
.filterDropDownData>a.active::after,
.filterDropDownData>a:hover:after,
.actionDropDownData>a:last-child::after,
.actionDropDownData>a.active::after,
.actionDropDownData>a:hover:after {
  display: none;
}

.pageDataWrapper {
  padding: 30px;
}

.contentHeader {
  background: #ebebeb;
  height: 42px;
  color: #484848;
  border-radius: 5px;
}

.contentHeader>div {
  border-left: 1px solid #c7c7c7;
  display: inline-flex;
  align-items: center;
}

.contentHeader>div:first-child {
  border-left: 0px solid;
}

.contentDataWrapper {
  overflow: auto;
  max-height: calc(100vh - 270px);
}

.contentData {
  background: #f8fafa;
  color: #6a6a6a;
  height: 60px;
  margin-top: 10px !important;
  cursor: pointer;
}

.contentData:hover,
.contentData.active {
  background: #f2fdff;
}

.contentData>div {
  border-left: 1px solid #e7e7e7;
  align-items: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
}

.contentData>div:first-child {
  border-left: 0px solid;
}

.devicesPageHeader {
  padding-left: 0;
}

.deviceStatus {
  height: 70px;
  line-height: 70px;
  padding: 0 30px;
  background: #66be6d;
 color:#fff;
}

.deviceStatus.offlineDevices {
  background: #f27778;
}

.deviceStatus.totalDevices {
  background: #3188D2;
}

.devicesPageHeader .filterWrapper {
  max-width: 200px;
  min-width: 200px;
}

.actionDropDown {
  background: #50b9d4;
  border-radius: 20px;
  color: #fff;
  float: right;
  padding: 5px 25px;
  width: 140px;
  text-align: left;
}

.actionDropDown:after {
  right: 30px;
  position: absolute;
  top: 15px;
}

.actionDropDown:hover {
  text-decoration: none;
}

.contentData>div .actionDropDown {
  background: transparent;
  border: 1px solid #dedede;
  color: #6a6a6a;
}

.deviceName {
  border-bottom: 1px solid #e7e7e7;
  padding-bottom: 5px !important;
  margin-bottom: 5px;
}

.deviceName>span {
  color: #50b9d4;
  padding-right: 15px;
}

.deviceDataWrapper .contentData {
  height: 80px;
}

.deviceDataWrapper .contentData>div:last-child {
  display: inline-flex;
  overflow: unset;
}

.importBtn {
  background: #1dd8f6;
  display: inline-flex;
  padding: 5px 15px;
  font-size: 16px;
  border-radius: 5px;
  margin-left: 15px;
  width: auto;
}

.importBtn:hover {
  color: #fff;
  cursor: pointer;
  background:#3288D2;
}

.hasNotifications {
  max-width: 160px;
}

.selectArea {
  max-width: 125px;
}

.userContentWrapper .contentData>div:first-child,
.userContentWrapper .contentData>div:nth-child(2) {
  display: flex;
}

.userContentWrapper .contentData>div span {
  color: #6a6a6a;
  padding-right: 5px;
}

.userDetailContentHeader {
  background: #f2fdff;
  color: #1a80a8;
  font-size: 16px;
  height: 60px;
}

.userDetailContentHeader>div {
  display: inline-flex;
}

.buttonItem {
  border: 1px solid #1dd8f6;
  border-radius: 5px;
  padding: 5px 20px;
  margin-left: 0px;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  background: #1dd8f6;
}

.buttonItem:hover {
  background: #3188D2;
  color: #fff;
  border:1px solid #3288D2;
}

.buttonItem img {
  margin-left: 15px;
}

.detailWrapper {
  padding: 30px;
  border-radius: 5px;
  border: 1px solid #a6e3f0;
  margin-top: 30px !important;
  max-height: calc(100vh - 300px);
}

.userDemograpics {
  width: 100%;
  padding-bottom: 30px !important;
  margin-bottom: 30px !important;
  border-bottom: 1px solid #dceaea;
}

.labelText {
  color: #1dd8f6;
}

.userDetails {
  width: 100%;
}

.userDetails .col:first-child {
  border-right: 1px solid #fdf7f7;
  padding-right: 30px;
}

.userDetails .col:last-child {
  padding-left: 30px;
}

.addBtn {
  border: 1px solid #dceaea;
  border-radius: 5px;
  padding: 7px 15px;
  color: #6a6a6a;
  width: 90px;
  text-align: center;
}

.selectListItems {
  width: calc(100% - 120px);
  margin-right: 30px;
}

.selectedItem {
  color: #6a6a6a;
  margin-top: 30px;
}

.selectedItem>img {
  margin-right: 15px;
}

.clearSelectedItems {
  color: #f27778;
  text-decoration: underline;
  padding-top: 30px;
}

.tfilters {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 15px;
}

.actionBtn.clientShowBtn {
  border-radius: 5px;
  min-width: 80px;
  text-align: center !important;
  display: inline-grid;
  background: #00b5da;
  color: #fff;
  line-height: 40px;
  padding: 0 15px;
  cursor: pointer;
  font-size: 16px;
}

.actionBtn.clientShowBtn:hover {
  background: #fff;
  color: #00b5da;
}

@media (max-width: 1919px) {
  .dashboardBlock {
    padding: 15px;
  }

  .dashboardIcon {
    margin-right: 10px;
  }

  .dashboardIcon>img {
    width: 22px;
  }

  .dashboardNumber {
    font-size: 32px;
  }

  .dashboardNumber>span {
    font-size: 12px;
    display: block;
    color: #6a6a6a;
  }

  .facilityName {
    font-size: 14px;
  }

  .facilityInfoWrapper {
    overflow: auto;
    max-height: calc(100vh - 220px);
  }

  .pageHeader {
    font-size: 20px;
  }

  .actionDropDown {
    width: 125px;
  }

  .userContentWrapper .contentData>div:nth-child(2) .text-right {
    text-align: left !important;
  }
}

@media (max-width: 1680px) {
  .facilityInfo {
    max-width: 315px;
  }
}

@media (max-width: 1600px) {
  .facilityInfo {
    max-width: 301px;
  }
}

@media (max-width: 1440px) {
  .dashboardBlock.count {
    flex-grow: 1.15;
  }

  .dashboardBlock.devices {
    flex-grow: 1.05;
  }

  .infoWrapper {
    border: none;
  }

  .facilityInfo .dashboardNumber {
    border-bottom: 1px solid #e5f0f2;
    min-width: 100%;
    text-align: left;
  }

  .facilityInfo {
    max-width: 365px;
    flex: 1 0 20%;
  }
}

@media (max-width: 1400px) {
  .dashboardBlock {
    flex-direction: column;
    text-align: center;
    gap: 15px;
  }

  .dashboardIcon {
    margin-right: 0;
  }
}

@media (max-width: 1366px) {
  .menuItem {
    padding-left: 20px;
  }
}

@media (max-width: 1360px) {
  .menuItem {
    padding-left: 20px;
  }
}

@media (min-width: 2133px) {
  .facilityInfo {
    max-width: 337px;
  }
}

@media (min-width: 2400px) {
  .facilityInfo {
    max-width: 381px;
  }
}

@media (min-width: 2560px) {
  .facilityInfo {
    max-width: 348px;
  }
}

@media (min-width: 2880px) {
  .facilityInfo {
    max-width: 342px;
  }
}

@media (min-width: 3840px) {
  .facilityInfo {
    max-width: 332px;
  }
}

@media (min-width: 5760px) {
  .facilityInfo {
    max-width: 322px;
  }
}

@media (min-width: 7680px) {
  .facilityInfo {
    max-width: 318px;
  }
}
</style>
